<template>
    <div class="flex py-3 items-center gap-3 justify-between w-full" :class="{ 'border-b border-slate-200': !isLastItem }">
        <a :href="episode.link" target="_blank" class="shrink-0">
            <img :src="episode.image" :alt="episode.title" class="w-12 h-12" />
        </a>
        <div class="flex flex-1 h-11 flex-col justify-center items-start gap-1 mx-3">
            <a :href="episode.link" target="_blank" class="hover:text-orange">
                <h3 class="text-md font-normal text-slate-800">
                    {{ episode.title }}
                </h3>
            </a>
            <div class="flex items-center gap-1 text-sm text-slate-500">
                <span>{{ formattedDate }}</span>
                <span>&#8226;</span>
                <span>{{ episode.duration }}</span>
            </div>
        </div>
        <a 
            :href="episode.link" 
            target="_blank" 
            class="flex px-4 py-2 items-start gap-2 rounded-md border border-slate-200 bg-white shadow-sm hover:bg-gray-50"
        >
            Listen
        </a>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    episode: {
        type: Object,
        required: true
    },
    isLastItem: {
        type: Boolean,
        default: false
    }
});

const formattedDate = computed(() => {
    const date = new Date(props.episode.date);
    return date.toLocaleDateString('en-US', { 
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
});
</script>
